import { render, staticRenderFns } from "./seeTopFive.vue?vue&type=template&id=463be02b&scoped=true"
import script from "./seeTopFive.vue?vue&type=script&lang=js"
export * from "./seeTopFive.vue?vue&type=script&lang=js"
import style0 from "./seeTopFive.vue?vue&type=style&index=0&id=463be02b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463be02b",
  null
  
)

export default component.exports